import React from 'react';

import { defineMessages, useIntl } from 'react-intl-next';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

export const i18n = defineMessages({
	introTextHeadline: {
		id: 'ai-smart-button.ai-dynamic-surface.components.greeting.intro-text-headline',
		defaultMessage: 'Hi {name},',
		description:
			'Greeting message displayed in panel openend by the AI Smart Button in right side of the screen',
	},
	introSecondline: {
		id: 'ai-smart-button.ai-dynamic-surface.components.greeting.intro-second-line',
		defaultMessage: 'How can I help?',
		description:
			'Second line of greeting message displayed in panel openend by the AI Smart Button in right side of the screen',
	},
});

const styles = cssMap({
	greetingText: {
		font: token('font.heading.large'),
		fontWeight: token('font.weight.semibold'),
	},
	container: {
		paddingInline: token('space.300'),
		paddingBlock: token('space.050'),
	},
});

export function Greeting({ name }: { name: string }) {
	const { formatMessage } = useIntl();

	return (
		<Box xcss={styles.container}>
			<Box xcss={styles.greetingText}>{formatMessage(i18n.introTextHeadline, { name })}</Box>
			<Box xcss={styles.greetingText}>{formatMessage(i18n.introSecondline)}</Box>
		</Box>
	);
}
